// inputタグのinputmode一覧
const INPUT_INPUTMODE = {
  TEXT: 'text',
  SEARCH: 'search',
  NONE: 'none',
  TEL: 'tel',
  URL: 'url',
  EMAIL: 'email',
  NUMERIC: 'numeric',
  DECIMAL: 'decimal',
} as const
type INPUT_INPUTMODE = typeof INPUT_INPUTMODE[keyof typeof INPUT_INPUTMODE]

/**
 * 指定したstringを返す。定義外の場合はundefinedを返す
 * @param input 入力データ
 * @returns 指定値 or undefined
 */
const toInputType = (input: string | undefined) => {
  switch (input) {
    case INPUT_INPUTMODE.TEXT:
    case INPUT_INPUTMODE.SEARCH:
    case INPUT_INPUTMODE.NONE:
    case INPUT_INPUTMODE.TEL:
    case INPUT_INPUTMODE.URL:
    case INPUT_INPUTMODE.EMAIL:
    case INPUT_INPUTMODE.NUMERIC:
    case INPUT_INPUTMODE.DECIMAL:
      return input
    default:
      return undefined
  }
}

export { INPUT_INPUTMODE, toInputType }
